import { render, staticRenderFns } from "./oeic-investment-choices-and-charges-panel.vue?vue&type=template&id=bbd359da&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports